import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../i18n";
import { STATS } from "../data/content";
import { Counter } from "../components/fx/Counter";
import { CircuitBackground } from "../components/fx/Backgrounds";
import { stagger, item } from "../components/fx/Reveal";

export const Stats = () => {
  const { lang } = useLang();
  return (
    <section className="relative overflow-hidden py-20 md:py-28">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(33,90,165,0.22),transparent_60%)]" />
      <CircuitBackground className="opacity-50" />
      <div className="container-pdr relative">
        <div className="mb-12 text-center">
          <span className="mono-label">{lang === "ro" ? "Cifre care contează" : "Numbers that matter"}</span>
        </div>
        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="grid grid-cols-2 gap-y-12 lg:grid-cols-4"
        >
          {STATS.map((s, i) => (
            <motion.div key={i} variants={item} className="relative text-center" data-testid={`stat-${i}`}>
              {i !== 0 && <span className="absolute left-0 top-1/2 hidden h-14 w-px -translate-y-1/2 bg-white/10 lg:block" />}
              <div className="font-display text-5xl font-extrabold text-gradient-glow md:text-6xl lg:text-7xl">
                <Counter value={s.value} suffix={s.suffix} decimals={s.decimals || 0} />
              </div>
              <p className="mt-3 text-sm uppercase tracking-wider text-white/55">{s[lang]}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
